module.exports = __webpack_public_path__ + "img/ep2-11-2.5e8d1b97.png";